import { render, staticRenderFns } from "./OrganisationActionDelete.vue?vue&type=template&id=78883caa&"
import script from "./OrganisationActionDelete.vue?vue&type=script&lang=ts&"
export * from "./OrganisationActionDelete.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports